import React, { useEffect, useContext } from "react";
import Image from "./../styled/Image";
import CardImage from "../styled/CardImage";
import { MainTitle, TitleSM, Subtitle } from "../styled/Typography";
import { useTranslation } from "react-i18next";
import { MdArrowBack, MdLocalGasStation, MdDirectionsCar, MdSettings } from "react-icons/md";
import ReactPlayer from "react-player";
import TagList from "./TagList";
import "./Meal.scss";
import GlobalContext from "../../context/GlobalContext";
import BannerRenderer from "../common/BannerRenderer";
import { Slide } from "react-slideshow-image";
import "react-slideshow-image/dist/styles.css";

const Slideshow = ({ slideImages }) => {
  slideImages = slideImages.filter((i) => i).filter((i) => i.startsWith("http"));
  if (!slideImages.length) return null;

  const buttonStyle = {
    width: "30px",
    background: "none",
    border: "0px",
  };

  const properties = {
    prevArrow: (
      <button style={{ ...buttonStyle }}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="#fff">
          <path d="M242 180.6v-138L0 256l242 213.4V331.2h270V180.6z" />
        </svg>
      </button>
    ),
    nextArrow: (
      <button style={{ ...buttonStyle }}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="#fff">
          <path d="M512 256L270 42.6v138.2H0v150.6h270v138z" />
        </svg>
      </button>
    ),
    transitionDuration: 300,
    autoplay: false,
  };

  if (slideImages.length === 1) {
    properties.arrows = false;
    properties.autoplay = false;
    properties.canSwipe = false;
  }

  return (
    <div className="slide-container">
      <Slide {...properties}>
        {slideImages.map((slideImage, index) =>
          slideImage.startsWith("http") ? (
            <div className="each-slide" key={index}>
              <div>
                <img src={slideImage} alt={`slide-${index}`} />
              </div>
            </div>
          ) : null
        )}
      </Slide>
    </div>
  );
};

const Meal = (props) => {
  const meal = props.location.state.meal;
  const { t } = useTranslation();
  const context = useContext(GlobalContext);

  if (meal.image && !meal.imagesUrls.length) meal.imagesUrls.push(meal.image);

  useEffect(() => {
    window.scrollTo(-1, 0);
  }, []);

  return (
    <div className="meal" style={{ filter: context.blur }}>
      {meal && (
        <div>
          {meal.imagesUrls.length > 0 && <Slideshow slideImages={meal.imagesUrls} />}

          <div
            className="meal-details"
            style={{
              background: context.configuration.uiConfig.mealDetailsBackgroundColor,
              minHeight: "90vh",
            }}
          >
            <MainTitle style={{ color: context.configuration.uiConfig.primaryFont }}>{meal.name}</MainTitle>
            <TitleSM style={{ color: context.configuration.uiConfig.primaryFont }}>{meal.price}</TitleSM>
            <Subtitle
              style={{
                whiteSpace: "pre-wrap",
                color: context.configuration.uiConfig.secondaryFont,
              }}
            >
              {meal.description}
            </Subtitle>

            {meal.ingredients && meal.ingredients.length > 0 && (
              <>
                <TitleSM style={{ color: context.configuration.uiConfig.primaryFont }}>{t("ingredients")}</TitleSM>
                <ul style={{ color: context.configuration.uiConfig.primaryFont }}>
                  {meal.ingredients.map((i) => (
                    <li key={i.id}>{i.name}</li>
                  ))}
                </ul>
              </>
            )}

            {meal.allergies && meal.allergies.length > 0 && (
              <div>
                <TitleSM style={{ color: context.configuration.uiConfig.primaryFont }}>{t("allergens")}</TitleSM>
                <div style={{ display: "flex", overflowX: "scroll", justifyContent: "flex-start" }}>
                  {meal.allergies.map((i) => (
                    <div style={{ display: "flex", flexDirection: "column" }} key={i.id}>
                      {i.image && <img alt="allergen" style={{ height: "10vh" }} src={i.image} />}
                      <Subtitle style={{ color: context.configuration.uiConfig.primaryFont }}>{i.name}</Subtitle>
                    </div>
                  ))}
                </div>
              </div>
            )}

            <TagList tags={meal.tags} />

            {/* Car Dealership Fields with Icons */}
            {context.configuration?.restaurantDetails?.type === "car-dealership" && (
              <div style={{ marginTop: "1rem", color: context.configuration.uiConfig.primaryFont }}>
                {meal.transmission && (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "0.5rem",
                      marginBottom: "0.5rem",
                    }}
                  >
                    <MdSettings size={24} />
                    <div>
                      <TitleSM>{t("Transmission")}</TitleSM>
                      <Subtitle>{meal.transmission}</Subtitle>
                    </div>
                  </div>
                )}
                {meal.body && (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "0.5rem",
                      marginBottom: "0.5rem",
                    }}
                  >
                    <MdDirectionsCar size={24} />
                    <div>
                      <TitleSM>{t("Body Type")}</TitleSM>
                      <Subtitle>{meal.body}</Subtitle>
                    </div>
                  </div>
                )}
                {meal.fuel && (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "0.5rem",
                      marginBottom: "0.5rem",
                    }}
                  >
                    <MdLocalGasStation size={24} />
                    <div>
                      <TitleSM>{t("Fuel Type")}</TitleSM>
                      <Subtitle>{meal.fuel}</Subtitle>
                    </div>
                  </div>
                )}
              </div>
            )}

            <ReactPlayer
              controls={true}
              url={meal.video}
              width={"100%"}
              height={300}
              style={{ maxWidth: 450 }}
            />
            {context.banner && (
              <BannerRenderer
                image={context.configuration?.restaurantDetails?.banner}
                link={context.configuration?.restaurantDetails?.bannerLink}
                linkEnabled={context.configuration?.restaurantDetails?.bannerLinkEnabled}
              />
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Meal;
